import { Title } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { RichTextArea } from "@mirage/mosaics/BaseProfilePage/RichTextArea/RichTextArea";
import i18n, { Trans } from "@mirage/translations";

import type { UserInfo } from "@mirage/mosaics/UserProfilePage/types";

interface EditProfileBodyProps {
  user: UserInfo;
}

export const EditUserProfileBody = ({ user }: EditProfileBodyProps) => {
  const aboutMe = user.about_me;
  return (
    <Box>
      <Title size="small" weightVariant="emphasized" tagName="span">
        {i18n.t("user_profile_about_me_string")}
      </Title>
      <Box marginTop="12">
        <RichTextArea
          source="EditUserProfilePage"
          editable
          topOffset={0}
          theme="small-faint"
          placeholder={
            <Trans
              i18nKey="user_profile_about_me_placeholder"
              components={{
                tag: <span />,
              }}
            />
          }
          value={aboutMe ?? undefined}
        />
      </Box>
    </Box>
  );
};
